export default {
    data() {
        return {
            hasModel:false,
        }
    },
    created () {
        const havaAuths = this.$store.state.controller.intellModel; // 用户拥有的权限列表

        for(let i=0;i<havaAuths.length;i++){
            
            if(!this.hasModel){
                if(havaAuths.indexOf('edit_DTT')>-1){
                    this.isGeneral = true;
                    this.hasModel=true;
                    this.activeOption("大体图/伍德灯", 0);
                    break;
                }
                if(havaAuths.indexOf('edit_PFJ')>-1){
                    this.skin = true;
                    this.hasModel=true;
                    this.activeOption("皮肤镜", 1);
                    break;
                }
                if(havaAuths.indexOf('edit_CT')>-1){
                    this.isCT = true;
                    this.hasModel=true;
                    this.activeOption("CT", 2);
                    break;
                }
                if(havaAuths.indexOf('edit_BC')>-1){
                    this.isBC = true;
                    this.hasModel=true;
                    this.activeOption("B超", 3);
                    break;
                }
                if(havaAuths.indexOf('edit_BL')>-1){
                    this.bl = true;
                    this.hasModel=true;
                    this.activeOption("病理", 4);
                    break;
                }
            }
        }
    },
}